import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";
import HeaderTwo from "../components/HeaderTwo";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/FooterTwo";
import Loading from "../components/Refine/Loading";
import Pagination from "../components/Refine/Pagination";
import ProductCard from "../components/Refine/ProductCard";
import axiosInstance from "../config/axios.config";
import { toast } from "react-toastify";
import { handleError } from "../utils/functions";

const Search = () => {
  const [searchParms] = useSearchParams();

  const categoryId = searchParms.get("categoryId");
  const name = searchParms.get("search");

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageSize: 10,
    totalItems: 0,
    totalPages: 1,
  });

  useEffect(() => {
    const getProducts = async () => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance({
          method: "GET",
          url: "/product/get",
          params: { categoryId, name },
        });
        if (!data.error) {
          setData(data.data);
          setPagination(data.pagination);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setIsLoading(false);
      }
    };

    getProducts();
  }, [categoryId, name]);

  return (
    <>
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderOne */}
      <HeaderTwo category={true} />

      <div className="banner mt-0">
        <img src="/assets/images/banner/product.jpg" className="w-100" alt="" />
      </div>

      <section className="productListingSection">
        <div className="container">
          <div className="row">
            <div className="">
              <Loading isLoading={isLoading}>
                <div className="row">
                  <p>
                    Total {data.length} results is Showing out of {pagination.totalItems}
                  </p>
                </div>
                <div className="row g-12">
                  {data.map((item) => (
                    <ProductCard item={item} key={item._id} className="col-lg-3 col-sm-4 col-6" />
                  ))}
                  <Pagination
                    totalPages={pagination.totalPages}
                    currentPage={pagination.currentPage}
                    handlePageChange={(value) => setPagination((prev) => ({ ...prev, currentPage: value }))}
                  />
                </div>
              </Loading>
            </div>
          </div>
        </div>
      </section>

      {/* ShippingTwo */}
      <ShippingTwo />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default Search;
